export default __webpack_public_path__ + "static/media/report-top-image.ee56f1e7.png";